


















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';
import UserItem from '@part/organisation/UserItem';

/* ----------------------------------------
    Component
---------------------------------------- */

    @Component({
        components: {
            UserItem,
        },

        methods: {
            canDelete(user) {
                return this.isAdmin && user.id !== this.authUser.data.id;
            },
            canChangeRole(user) {
                const multipleAdmins = this.users.some(user => user.admin && user.id !== this.authUser.data.id);
                return this.isAdmin && (user.id !== this.authUser.data.id || multipleAdmins);
            },
            removeUser(payload) {
                this.$emit('remove-user', payload);
            },
            updateUserRole(payload) {
                this.$emit('update-user-role', payload);
            },
        },

        computed: {
            isAdmin() {
                return this.users.some(user => user.admin && user.id === this.authUser.data.id);
            }
        }
    })

/* ----------------------------------------
    Export
---------------------------------------- */

export default class UserHeader extends Vue {
    @Prop() users!: object|null
    @Prop() organisation!: object|null
};

